// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface TemplateFileCreate
 */
export interface TemplateFileCreate {
    /**
     * ID of docx template file
     * @type {string}
     * @memberof TemplateFileCreate
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileCreate
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileCreate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileCreate
     */
    context: TemplateFileCreateContextEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TemplateFileCreateContextEnum {
    Act = 'act',
    Bill = 'bill',
    Contract = 'contract',
    EducationProtocol = 'education-protocol',
    EnrollmentOrder = 'enrollment-order',
    ExpulsionOrder = 'expulsion-order',
    FinalDocument = 'final-document'
}



